import React from "react";
import { MacroChartReference } from "models/AiResearch";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styles from "./style.scss";

interface Props {
  reference: MacroChartReference;
}

export const MacroChart: React.FC<Props> = ({ reference }) => {
  const options: Highcharts.Options = {
    title: {
      text: "",
      useHTML: true,
      style: {
        whiteSpace: "normal"
      }
    },
    yAxis: {
      title: { text: reference.data.content.yLabel },
      labels: {
        formatter() {
          return Highcharts.numberFormat(this.value as number, 0);
        }
      }
    },
    xAxis: {
      title: { text: reference.data.content.xLabel },
      categories: reference.data.content.series[0].values.map(v => v.x),
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6"
    },
    series: [
      {
        type: "column",
        data: reference.data.content.series[0].values.map(v => v.y),
        name: reference.data.meta.name
      }
    ],
    exporting: {
      enabled: false
    },
    credits: {
      enabled: false
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.citationNumber}>{reference.citationNumber}</span>
      <h2 className={styles.title}>{reference.data.meta.name}</h2>
      <p className={styles.description}>{reference.data.meta.definition}</p>
      <div className={styles.chartContainer}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={{ className: styles.chartInner }}
        />
      </div>
      <h3 className={styles.subtitle}>調査名</h3>
      <div>{reference.data.meta.surveyTitle}</div>
      <h3 className={styles.subtitle}>調査機関</h3>
      <div>{reference.data.meta.surveyOrganization}</div>
      <h3 className={styles.subtitle}>利用シーン</h3>
      <div>{reference.data.meta.usageScene}</div>
    </div>
  );
};
